"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _IconWrapper = _interopRequireDefault(require("./IconWrapper"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var FoodProduction = function FoodProduction(_ref) {
  var viewBox = _ref.viewBox;
  return /*#__PURE__*/_react.default.createElement(_IconWrapper.default, {
    viewBox: viewBox
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.33947 16.45L9.43421 15.65C10.0263 10.75 11.0684 7 12.9868 7C14.7395 7 15.5684 7 17.2974 7C19.2395 7 20.2816 10.75 20.8737 15.65L20.9684 16.45C21.5842 16.6 24.3079 17.1 24.3079 18.5C24.3079 20.95 16.1132 21 15.1421 21C14.1947 21 6 20.95 6 18.5C6 17.1 8.72368 16.6 9.33947 16.45Z",
    fill: "#F06C00",
    fillOpacity: "0.5"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.33947 16.45L9.43421 15.65C10.0263 10.75 11.0684 7 12.9868 7C14.7395 7 15.5684 7 17.2974 7C19.2395 7 20.2816 10.75 20.8737 15.65L20.9684 16.45C21.5842 16.6 24.3079 17.1 24.3079 18.5C24.3079 20.95 16.1132 21 15.1421 21C14.1947 21 6 20.95 6 18.5C6 17.1 8.72368 16.6 9.33947 16.45ZM9.88421 15.9L9.83684 16.35C13.2711 15.8 17.0132 15.8 20.4711 16.35L20.4237 15.9C19.8553 11.25 18.8605 8 17.2974 8C15.6632 8 14.6211 8 12.9868 8C11.4474 8 10.4526 11.25 9.88421 15.9ZM15.1421 20C18.5868 20.0016 23.2188 19.6 23.2188 18.5C23.2188 17.4 18.5901 16.9484 15.1421 16.95C11.7032 16.9516 7.0625 17.4 7.0625 18.5C7.0625 19.6 11.7066 19.9984 15.1421 20Z",
    stroke: "#7F0442",
    strokeWidth: "1.1"
  }));
};

FoodProduction.propTypes = {
  viewBox: _propTypes.PropTypes.string
};
FoodProduction.defaultProps = {
  viewBox: '0 0 30 30'
};
var _default = FoodProduction;
exports.default = _default;